import { action } from 'typesafe-actions';
// eslint-disable-next-line no-unused-vars
import { OperatorsTypes, OperatorInterface } from './types';

// List Operator
export const listOperatorRequest = (payload: object) =>
  action(OperatorsTypes.LIST_OPERATOR_REQUEST, payload);
export const listOperatorSuccess = (payload: {
  operatorsList: OperatorInterface[];
}) => action(OperatorsTypes.LIST_OPERATOR_SUCCESS, payload);
export const listOperatorFailure = () =>
  action(OperatorsTypes.LIST_OPERATOR_FAILURE);

// Create Operator
export const createOperatorRequest = (payload: {
  name?: string;
  cnpj: string;
  recaptcha: any;
  picture?: string;
  supervisors: {
    name?: string;
    email: string;
    modules: string[];
    picture?: string;
  }[];
  transportOperatorIds?: string[];
}) => action(OperatorsTypes.CREATE_OPERATOR_REQUEST, payload);
export const createOperatorSuccess = (payload: {
  operatorCreated: OperatorInterface;
}) => action(OperatorsTypes.CREATE_OPERATOR_SUCCESS, payload);
export const createOperatorFailure = () =>
  action(OperatorsTypes.CREATE_OPERATOR_FAILURE);

// Update Operator
export const updateOperatorRequest = (payload: object) =>
  action(OperatorsTypes.UPDATE_OPERATOR_REQUEST, payload);
export const updateOperatorSuccess = () =>
  action(OperatorsTypes.UPDATE_OPERATOR_SUCCESS);
export const updateOperatorFailure = () =>
  action(OperatorsTypes.UPDATE_OPERATOR_FAILURE);

// Select Operator
export const selectOperatorRequest = (payload: {
  operatorSelected: OperatorInterface;
}) => action(OperatorsTypes.SELECT_OPERATOR_REQUEST, payload);
export const selectOperatorSuccess = (payload: {
  operatorSelected: OperatorInterface;
}) => action(OperatorsTypes.SELECT_OPERATOR_SUCCESS, payload);
export const selectOperatorFailure = () =>
  action(OperatorsTypes.SELECT_OPERATOR_FAILURE);
